import type { ContentAction } from '@lumapps/contents/types';

export enum DESIGNER_TRANSLATIONS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=855228355
     */
    ALL_LANGUAGES = 'DESIGNER_TRANSLATIONS.ALL_LANGUAGES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=848537039
     */
    ALL_LANGUAGES_NUMBER = 'DESIGNER_TRANSLATIONS.ALL_LANGUAGES_NUMBER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=677248285
     */
    AUTOTRANSLATE_ALL_EMPTY_ERROR = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE_ALL_EMPTY_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=855366120
     */
    AUTOTRANSLATE_ALL_SELECTED_LANGUAGES = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE_ALL_SELECTED_LANGUAGES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=677248166
     */
    AUTOTRANSLATE_ALL_UNCHECKED_ERROR = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE_ALL_UNCHECKED_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=677207976
     */
    AUTOTRANSLATE_BUTTON_LABEL = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE_BUTTON_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=653714753
     */
    EMPTY_CONTENT_DIALOG_DESCRIPTION = 'DESIGNER_TRANSLATIONS.EMPTY_CONTENT_DIALOG_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=653714714
     */
    EMPTY_CONTENT_DIALOG_TITLE = 'DESIGNER_TRANSLATIONS.EMPTY_CONTENT_DIALOG_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=663149182
     */
    EMPTY_WIDGET_MESSAGE = 'DESIGNER_TRANSLATIONS.EMPTY_WIDGET_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847450250
     */
    MISSING_TRANSLATION_DIALOG_EXPLANATION_MESSAGE = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847450562
     */
    MISSING_TRANSLATION_DIALOG_PUBLISH_ANYWAY = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_PUBLISH_ANYWAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847453997
     */
    MISSING_TRANSLATION_DIALOG_PUBLISH_TITLE = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_PUBLISH_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847453729
     */
    MISSING_TRANSLATION_DIALOG_SAVE_ANYWAY = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SAVE_ANYWAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847454025
     */
    MISSING_TRANSLATION_DIALOG_SAVE_TITLE = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SAVE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847453926
     */
    MISSING_TRANSLATION_DIALOG_SCHEDULE_ANYWAY = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SCHEDULE_ANYWAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847454053
     */
    MISSING_TRANSLATION_DIALOG_SCHEDULE_TITLE = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SCHEDULE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847453966
     */
    MISSING_TRANSLATION_DIALOG_SUBMIT_ANYWAY = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SUBMIT_ANYWAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847454124
     */
    MISSING_TRANSLATION_DIALOG_SUBMIT_TITLE = 'DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SUBMIT_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=847457988
     */
    NOT_UPDATED = 'DESIGNER_TRANSLATIONS.NOT_UPDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=661077319
     */
    SOURCE_LANGUAGE_LABEL = 'DESIGNER_TRANSLATIONS.SOURCE_LANGUAGE_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=675317912
     */
    SWITCH_ALERT_CONFIRM = 'DESIGNER_TRANSLATIONS.SWITCH_ALERT_CONFIRM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=675343279
     */
    SWITCH_ALERT_MESSAGE_EXPLANATION = 'DESIGNER_TRANSLATIONS.SWITCH_ALERT_MESSAGE_EXPLANATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=675343366
     */
    SWITCH_ALERT_MESSAGE_HELP = 'DESIGNER_TRANSLATIONS.SWITCH_ALERT_MESSAGE_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=675314146
     */
    SWITCH_ALERT_TITLE = 'DESIGNER_TRANSLATIONS.SWITCH_ALERT_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=661077355
     */
    TARGET_LANGUAGE_LABEL = 'DESIGNER_TRANSLATIONS.TARGET_LANGUAGE_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838449967
     */
    TRANSLATE_CHANGES = 'DESIGNER_TRANSLATIONS.TRANSLATE_CHANGES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=659704953
     */
    TRANSLATION_DIALOG_TITLE = 'DESIGNER_TRANSLATIONS.TRANSLATION_DIALOG_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=855366620
     */
    VIEW_IN = 'DESIGNER_TRANSLATIONS.VIEW_IN',
}
export const MISSING_TRANSLATION_DIALOG_TITLE_KEYS: Record<ContentAction, DESIGNER_TRANSLATIONS> = {
    publish: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_PUBLISH_TITLE,
    save: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SAVE_TITLE,
    schedule: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SCHEDULE_TITLE,
    'submit-for-review': DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SUBMIT_TITLE,
};

export const MISSING_TRANSLATION_DIALOG_SKIP_KEYS: Record<ContentAction, DESIGNER_TRANSLATIONS> = {
    publish: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_PUBLISH_ANYWAY,
    save: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SAVE_ANYWAY,
    schedule: DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SCHEDULE_ANYWAY,
    'submit-for-review': DESIGNER_TRANSLATIONS.MISSING_TRANSLATION_DIALOG_SUBMIT_ANYWAY,
};
